module.exports = __webpack_public_path__ + "img/gallery-7.949c5b98.jpg";